import GoogleAutoComplete from 'components/GoogleAutoComplete';
import classNames from 'classnames';
import styles from './InputForm.module.scss';
import moment from 'moment-timezone';

export const AutoComplete = ({
    addressError,
    handleOnChange,
    router,
    store,
    userLogin,
    address,
    internalAddress,
    setAddress,
  }) => {
    return (
      <GoogleAutoComplete
        className={classNames(
          `input-light-1 outline-none focus:outline-none address-inputs font-inter-medium my-0 rounded-lg text-md text-primary-black w-full`,
        )}
        onChange={e => {
          // Clear previously selected city when user types a new address
          store.userStore.setSelectedCity('');
          handleOnChange(e);
        }}
        placeholder="Enter Address"
        value={userLogin ? address : internalAddress?.address}
        // value={internalAddress?.address}
        onBlur={e => {
          const queryDate = router?.query?.date;
    
          store.userStore.getAvailableDates({
            address: e?.target?.value,
            month: queryDate ? moment(queryDate).month() + 1 : moment().month() + 1,
            year: queryDate ? moment(queryDate).year() : moment().year(),
            current_date_time: moment().format('YYYY-MM-DD HH:mm'),
          });
        }}
        onPlaceSelected={place => {
          store.userStore?.getAndSetTimezone(place?.formatted_address);
          const _address = place?.address_components?.reduce(
            (seed, { long_name, short_name, types }) => {
              types.forEach(t => {
                if (t == 'administrative_area_level_1') {
                  seed[t] = short_name; // Set short_name for province
                } else {
                  seed[t] = long_name; // Set long_name for other types
                }
              });
              return seed;
            },
            {}
          );
    
          setAddress({
            address: place?.formatted_address,
            completeAddress: {
              suite: _address?.subpremise,
              street_number: _address?.street_number,
              street_name: _address?.route,
              city: _address?.locality,
              province: _address?.administrative_area_level_1,
              postal_code: _address?.postal_code,
              destination_code: '',
            },
          });
    
          // store?.userStore?.setAddress(place?.formatted_address, {
          //   suite: _address?.subpremise,
          //   street_number: _address?.street_number,
          //   street_name: _address?.route,
          //   city: _address?.locality,
          //   province: _address?.administrative_area_level_1,
          //   postal_code: _address?.postal_code,
          //   destination_code: '',
          // });
        }}
      />
  );
}

export const Error = ({ message = 'Please select a valid address from the list.' }) => (
  <span className="text-attention text-xs mt-1 animate-fade-in-down" style={{color: '#C31828'}}>{message}</span>
);